import type { FC } from "react";
import clsx from "clsx";
import Link from "next/link";
import { responsive } from "utils/theme";
import Image from "components/Image";
import styled from "styled-components";
import { useLocale } from "hooks";
import translation, { MAPPED_TAB_URL } from "../translation";
import DateUtils from "utils/DateUtils";
import { TABS } from "./constants";
import { generateImage } from "utils/newFunction";
import { slugMaker } from "utils/normalizer";

interface News {
  id: number | string;
  link: string;
  image: string;
  title: string;
  date: string;
}

interface IProps {
  activeTab: string;
  className: string;
  item: any;
}

const normalizer = (item, activeTab: string, locale: string): News => {
  return {
    id: item.id || 0,
    title: item.title?.value || "",
    link: `/${MAPPED_TAB_URL[activeTab] || "news"}/${item?.id}/${
      item?.metaTag?.slug || slugMaker(item?.title?.value)
    }`,
    date:
      locale === "fa"
        ? DateUtils.parsePersianhNewsDate(item?.publish_date?.value)
        : DateUtils.parseEnglishNewsDate(item?.publish_date?.value),
    image: generateImage(item.cover_image?.value),
  };
};

const NewsEventCard: FC<IProps> = ({ item, className, activeTab }) => {
  const { locale } = useLocale();
  const data = normalizer(item, activeTab, locale);
  return (
    <Link href={data?.link}>
      <a className={clsx("tw-flex tw-flex-col tw-group", className)}>
        <div className="tw-w-full tw-bg-[#e7eaf1]">
          <div className="tw-relative tw-rounded-lg tw-overflow-hidden tw-aspect-[3/2]">
            <Image
              width={600}
              height={400}
              src={data?.image}
              alt={data?.title}
              className="tw-transition-all tw-w-full tw-h-full tw-object-cover tw-object-center"
            />
            <div className="tw-rounded-lg tw-text-lg te-font-medium tw-absolute tw-top-0 tw-w-full tw-h-full tw-flex tw-bg-gradient-to-b tw-items-end tw-pr-5 tw-pb-4 gradiant"></div>
          </div>
        </div>
        <span className="tw-text-[#344456] tw-text-base xxxl:tw-text-[21.33px] tw-leading-[36.17px] tw-font-bold tw-mt-4 xxxl:tw-mt-5 group-hover:tw-text-[#007FAC] tw-transition-all tw-min-h-[50px] xxxl:tw-min-h-[70px] title">
          {data?.title}
        </span>
        <p className="tw-text-[#344456]/40 tw-text-[13px] xxxl:tw-text-[17.33px] tw-mt-1">
          <span>
            {activeTab === TABS[1]
              ? translation[locale]?.EVENTS_PUBLISH_DATE
              : translation[locale]?.NEWS_PUBLISH_DATE}
            :{" "}
          </span>
          <span>{data?.date}</span>
        </p>
      </a>
    </Link>
  );
};
const StyledNewsEventCard = styled(NewsEventCard)`
  .title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
  }
  .gradiant {
    background: linear-gradient(
      180deg,
      rgba(52, 68, 86, 0) 66.67%,
      rgba(52, 68, 86, 0.7) 100%
    );
  }
  img {
    transition: transform 0.3s;
    @media (max-width: ${responsive.md}px) {
      transform: scaleY(1.06);
    }
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

export default StyledNewsEventCard;
